import { ValidationResult } from "./validation-result";

export interface ServiceDef {
    id: number;
    agencyId: number;
    serviceRequestTypeId: number;
    description: string | null;
    unitOfMeasure: string | null;
    durationDays: number;
    activeStatus: string | null;
    isChecked: boolean;
    dowAvailable: string | null;
    emailSuffix: string | null;
    useAutomatch: string | null;
    repeatable: string | null;
    repeatFrequency: number;
    defaultMembers: string;
}

export class ServiceDef {
    constructor() {
        this.id = 0;
        this.agencyId = 0;
        this.serviceRequestTypeId = 0;
        this.unitOfMeasure = '';
        this.durationDays = 0;
        this.description = '';
        this.activeStatus = '';
        this.dowAvailable = '';
        this.emailSuffix = '';
        this.useAutomatch = '';
        this.repeatFrequency = 0;
        this.repeatable = 'No';
        this.defaultMembers = 'A';
    }
    public setRecord(val:any) : void {
        this.id = val.id;
        this.agencyId = val.agencyId;
        this.serviceRequestTypeId = val.serviceRequestTypeId;
        this.unitOfMeasure = val.unitOfMeasure;
        this.durationDays = val.durationDays;
        this.description = val.description;
        this.activeStatus = val.activeStatus;
        this.dowAvailable = val.dowAvailable;
        this.emailSuffix = val.emailSuffix;
        this.useAutomatch = val.useAutomatch;
        this.repeatFrequency = val.repeatFrequency;
        this.repeatable = val.repeatable;
        this.defaultMembers = val.defaultMembers;
    }
    validateRecord(): ValidationResult {
        const vr: ValidationResult = new ValidationResult();

        if ((this.serviceRequestTypeId === 0) || (this.serviceRequestTypeId === null)) {
            vr.error = 'Error: A Service Type is required';
            vr.focus_field = 'serviceTypeId';
            return vr;
        }

        if(this.description.length === 0) {
            vr.error = 'Error: A Service Description is required';
            vr.focus_field = 'description';
            return vr;
        }

        if(this.unitOfMeasure.length === 0) {
            vr.error = 'Error: A unit of measure is required';
            vr.focus_field = 'unitOfMeasure';
            return vr;
        }

        if(this.durationDays < 1) {
            vr.error = 'Error: the duration days cannot be zero (0)';
            vr.focus_field = 'durationDays';
            return vr;
        }
        
         if(this.repeatable === 'Yes') {

             if(this.repeatFrequency < 0) {
                 vr.error = 'Error: the Repeat frequency cannot be less than zero';
                 vr.focus_field = 'repeatFrequency';
                 return vr;
             }
             if(this.repeatFrequency > 4000) {
                 vr.error = 'Error: the Repeat frequency cannot be more than 4000';
                 vr.focus_field = 'repeatFrequency';
                 return vr;
             }
        }

        if(this.dowAvailable.length === 0) {
            vr.error = 'Error: No days available have been specified';
            vr.focus_field = 'dowAvailable';
            return vr;
        }
        return vr;

    }
}
